var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.461 457.949h344.616v-85.026q0-51.282-35.866-87.18-35.866-35.897-87.102-35.897-51.237 0-87.212 35.897-35.974 35.898-35.974 87.18h-33.846q0-65.718 45.707-111.321Q414.492 216 480.105 216t111.216 45.676q45.602 45.677 45.602 111.247v85.026h64.616q23.91 0 41.186 17.076Q760 492.102 760 516.41v361.129q0 23.91-17.275 41.186Q725.449 936 701.539 936H258.461q-23.91 0-41.186-17.275Q200 901.449 200 877.539V516.41q0-24.308 17.275-41.385 17.276-17.076 41.186-17.076Zm0 444.205h443.078q10.769 0 17.692-6.923t6.923-17.692V516.41q0-10.769-6.923-17.692t-17.692-6.923H258.461q-10.769 0-17.692 6.923t-6.923 17.692v361.129q0 10.769 6.923 17.692t17.692 6.923ZM480.112 756q24.529 0 41.721-17.136 17.193-17.136 17.193-41.582 0-23.82-17.305-41.577-17.304-17.756-41.833-17.756t-41.721 17.756q-17.193 17.757-17.193 41.91 0 24.154 17.305 41.27Q455.583 756 480.112 756ZM233.846 902.154V491.795 902.154Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.3e98c23252291f97f3692c1201e47948.svg";
export { ForwardRef as ReactComponent };